<div class="col-xs-12" {{amIHidden}}>
	<div class="text-center {{myClass}}">
		{{message}}
	</div>
</div>